import { App, Flex, Form, Input } from "antd"
import { Button } from "src/global/ui/Button/Button.tsx"
import { AppModal } from "src/global/ui/AppModal/AppModal.tsx"
import { RequestSourceModalConfig } from "src/global/ui/Menu/SalesDemoModal.tsx"
import { useAnalytics } from "src/global/hooks/analytics/useAnalytics.ts"
import { DataSourceCard } from "src/pages/DataAssets/components/DataSourceCard.tsx"
import { Icon } from "src/global/ui/Icon"
import { useState } from "react"

const REQUEST_SOURCE_FIELD_VALUE = "request_a_source"
export const REQUEST_SOURCE_ANALYTICS_EVENT = "add_data_source_card_selected.request_a_source"

type RequestSourceModalProps = {
  isModalVisible: boolean
  setIsModalVisible: (isModalVisible: boolean) => void
}

function RequestSourceModal({ isModalVisible, setIsModalVisible }: RequestSourceModalProps) {
  const { modal } = App.useApp()
  const [form] = Form.useForm()
  const { capture } = useAnalytics()

  const reset = () => {
    form.resetFields()
    setIsModalVisible(false)
  }

  const onFinish = () => {
    capture(REQUEST_SOURCE_ANALYTICS_EVENT, {
      requested_source: form.getFieldValue(REQUEST_SOURCE_FIELD_VALUE),
    })
    modal.info({
      ...RequestSourceModalConfig,
      onCancel: () => {
        capture("request_a_source.modal_dismissed")
        reset()
      },
    })
  }
  return (
    <AppModal
      centered
      open={isModalVisible}
      onCancel={reset}
      destroyOnClose
      footer={
        <>
          <Flex justify="center">
            <Button htmlType="submit" type="primary" form="request_source" name="request_source_submit">
              Submit
            </Button>
          </Flex>
        </>
      }
    >
      <>
        <Form id="request_source" layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item required label="What Data Source would you like to connect to?" name={REQUEST_SOURCE_FIELD_VALUE}>
            <Input.TextArea required />
          </Form.Item>
        </Form>
      </>
    </AppModal>
  )
}

export function RequestSourceCard() {
  const { capture } = useAnalytics()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleRequestSourceOnClick = () => {
    capture(REQUEST_SOURCE_ANALYTICS_EVENT)
    setIsModalVisible(true)
  }

  return (
    <>
      <RequestSourceModal isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} />
      <DataSourceCard
        onClick={handleRequestSourceOnClick}
        image={<Icon name="commentAltQuestion" />}
        text="Request a source"
      />
    </>
  )
}
